
const BLACK_LIST = [
  "C4", "C6",
  "D6", "D7", "D8", "D9", "D10", "D11","D5P",
  "E8", "E1P", "E2P",
  "I6", "I7", "I9",
  "M4", "M6", "M8",
  "P4",
  "T2","T3","T4", "T5", "T6","T9",
];

export default BLACK_LIST;